import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import axios from "axios";
import "./SearchResults.css";

const SearchResults = () => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const searchQuery = new URLSearchParams(location.search).get("query");

  useEffect(() => {
    const fetchResults = async () => {
      setLoading(true);
      try {
        const response = await axios.get("https://api.swasthmitra.com/api/medicine");

        const filteredResults = response.data.filter((medicine) =>
          medicine.name?.toLowerCase().includes(searchQuery.toLowerCase()) || 
          medicine.brand?.toLowerCase().includes(searchQuery.toLowerCase()) || 
          medicine.salt?.toLowerCase().includes(searchQuery.toLowerCase())
        );

        setResults(filteredResults);
      } catch (error) {
        console.error("Error fetching results:", error);
      }
      setLoading(false);
    };

    if (searchQuery) {
      fetchResults();
    }
  }, [searchQuery]);

  if (loading) {
    return <div className="search-loading">Loading...</div>;
  }

  return (
    <div className="search-results">
      <h2>Search Results for "{searchQuery}"</h2>
      {results.length === 0 ? (
        <p>No results found for your search.</p>
      ) : (
        <>
          <p className="results-count">{results.length} results found</p>
          <div className="results-grid">
            {results.map((medicine) => (
              <Link to={`/product/${medicine._id}`} className="result-link" key={medicine._id}>
                <div className="result-card">
                  <img 
                    src={medicine.imageUrl || medicine.imageUrls?.[0] || "/default-medicine.png"} 
                    alt={medicine.name} 
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/default-medicine.png";
                    }}
                  />
                  <h3>{medicine.name}</h3>
                  <div className="medicine-details">
                    {medicine.brand && <p className="brand">Brand: {medicine.brand}</p>}
                    {medicine.salt && <p className="salt">Salt: {medicine.salt}</p>}
                  </div>
                  <p className="price">₹{medicine.dealRate || medicine.mrp}</p>
                  <p className="category">{medicine.category}</p>
                  {medicine.description && <p className="description">{medicine.description}</p>}
                </div>
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SearchResults;
